// In order to use requiredIf and showIf, file needs to be .js so they can be functions.
module.exports = {
  name: "FRP Information",
  fields: [
    {
      name: "First Name",
      size: {
        xs: "12",
        md: "4",
      },
      value: "firstName",
      type: "Input",
      mask: {
        type: "alpha",
        options: {
          maxLength: 35,
        },
      },
      placeholder: "",
      options: [],
      validation: {
        required: true,
        alpha: true,
        maxLength: 35,
      },
      error: "Please enter a First Name",
      trim: true,
    },
    {
      name: "MI",
      size: {
        xs: "12",
        md: "4",
      },
      value: "middleInitial",
      type: "Input",
      mask: {
        type: "alpha",
        options: {
          maxLength: 1,
        },
      },
      placeholder: "",
      options: [],
      validation: {
        required: false,
        alpha: true,
        maxLength: 1,
      },
      trim: true,
    },
    {
      name: "Last Name",
      size: {
        xs: "12",
        md: "4",
      },
      value: "lastName",
      type: "Input",
      mask: {
        type: "alpha",
        options: {
          maxLength: 35,
        },
      },
      placeholder: "",
      options: [],
      validation: {
        required: true,
        alpha: true,
        maxLength: 35,
      },
      error: "Please enter a Last Name",
      trim: true,
    },
    {
      name: "Home Phone",
      size: {
        xs: "12",
        md: "4",
      },
      value: "phoneNumber",
      type: "Input",
      mask: "phone",
      placeholder: "",
      options: [],
      validation: {
        requiredIf: (data) => {
          return data.mobileNumber === "";
        },
        phone: true,
      },
      error: {
        phone: "Please enter a valid phone number",
        default: "A home or mobile phone number is required",
      },
      errorOrder: ["default", "phone"],
      trim: true,
      hint: {
        value: "Enrollment requires a home or mobile phone number",
      },
      componentProps: {
        disableOptionalTag: true,
      },
    },
    {
      name: "Mobile Phone",
      size: {
        xs: "12",
        md: "4",
      },
      value: "mobileNumber",
      type: "Input",
      mask: "phone",
      placeholder: "",
      options: [],
      validation: {
        requiredIf: (data) => {
          return data.phoneNumber === "";
        },
        phone: true,
      },
      error: {
        phone: "Please enter a valid phone number",
        default: "A home or mobile phone number is required",
      },
      errorOrder: ["default", "phone"],
      trim: true,
      componentProps: {
        disableOptionalTag: true,
      },
    },
    {
      name: "Work Phone",
      size: {
        xs: "12",
        md: "4",
      },
      value: "workNumber",
      type: "Input",
      mask: "phone",
      placeholder: "",
      options: [],
      validation: {
        required: false,
        phone: true,
      },
      error: "Please enter a valid phone number",
      trim: true,
    },
    {
      name: "Social Security Number",
      size: {
        xs: "12",
        md: "4",
      },
      value: "ssn",
      type: "Ssn",
      mask: "",
      placeholder: "",
      options: [],
      validation: {
        required: true,
        ssn: true,
        maxNumLength: 9,
        minNumLength: 9,
      },
      error: {
        ssn: "Please enter a valid Social Security Number",
        maxNumLength: "Please enter a valid Social Security Number",
        minNumLength: "Please enter a valid Social Security Number",
        default: "Please enter a Social Security Number",
      },
      errorOrder: ["default", "maxNumLength", "minNumLength", "ssn"],
    },
    {
      name: "Date of Birth",
      size: {
        xs: "12",
        md: "4",
      },
      value: "dateOfBirth",
      type: "Input",
      mask: "date",
      placeholder: "",
      options: [],
      validation: {
        required: true,
        date: true,
        minimumAge: 18,
      },
      error: {
        minimumAge: "Must be 18 years or older",
        default: "Please enter a valid Date of Birth",
      },
      errorOrder: ["default", "minimumAge"],
      trim: true,
    },
    {
      name: "Email Address",
      size: {
        xs: "12",
        md: "4",
      },
      value: "emailAddress",
      type: "Input",
      mask: {
        type: "maxLength",
        options: {
          length: 50,
        },
      },
      placeholder: "",
      options: [],
      validation: {
        required: true,
        email: true,
        maxLength: 50,
      },
      error: "Please enter a valid email address",
      trim: true,
    },
  ],
};
